// @flow

import * as React from 'react';
import styled from 'styled-components';
import { SmallText } from '../Text';

type Props = {
  id?: string,
  children?: React.Node,
  left?: React.Node,
  right?: React.Node,
  noteText: string,
};

const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;
const LeftDiv = styled.div`
  flex: 1;
  display: flex;
`;
const RightDiv = styled.div`
  flex: 1;
  display: flex;
  text-align: right;
  justify-content: flex-end;
`;

export class OverviewItem extends React.Component<Props> {
  props: Props;

  render() {
    return <li>{this.props.children}</li>;
  }
}

export class SplitOverviewItem extends OverviewItem {
  render() {
    return (
      <OverviewItem>
        <Container>
          <LeftDiv>{this.props.left}</LeftDiv>
          <RightDiv>{this.props.right}</RightDiv>
        </Container>
      </OverviewItem>
    );
  }
}

export class NoteOverviewItem extends OverviewItem {
  render() {
    return (
      <OverviewItem>
        <Container>
          <LeftDiv>{this.props.left}</LeftDiv>
          <RightDiv>{this.props.right}</RightDiv>
        </Container>
        <RightDiv>
          <SmallText textId={this.props.noteText} />
        </RightDiv>
      </OverviewItem>
    );
  }
}
